export const CONFERENCE_INFO = {
    alwaysVisible: ['raised-hands-count', 'recording'],
    autoHide: [
        'highlight-moment',
        'subject',
        'conference-timer',
        'participants-count',
        'e2ee',
        'transcribing',
        'video-quality',
        'visitors-count',
        'insecure-room',
        'top-panel-toggle',
        'odonto-help'
    ]
};
